export const getStreetNumber = (addressLine1?: string): string | null => {
  if (!addressLine1) return null;
  const parts = addressLine1.split(" ");

  // Only return the first part if it's numeric (or starts with a number)
  return Number.isNaN(Number(parts[0])) ? null : parts[0];
};
